import React from "react";
import { Grid } from "@material-ui/core";
import { LabelDecimal, LabelDollarFormatted } from "@loanbossinc/component-library";

import { Row } from "../styles";
import CalcIconBlue from "../../../calcIconBlue.svg";

import {
  FieldIconWrapper,
  FieldLeftContentWrapper,
  FieldLevelWrapper,
  FieldNameTypeWrapper,
  FieldNameWrapper,
  FieldRightContentWrapper,
  FieldWrapper,
  RemoveWrapper,
  StyledChevronRight
} from "./calculatedFieldStyles";
import { OperationsBar } from "./operationsBar";

const getSelectedField = (calculation, fields) => (
  calculation.type === "field"
  && Boolean(calculation.fieldId)
  && fields.find(x => x.id === calculation.fieldId)
);

export const PredefinedCalculationField = props => {

  const { calculation, fields, idx, numberOfCalculations, onRemoveCalculation, onSelectNewField, onSetOperation, rowProps } = props;

  const getFieldName = fieldId => {
    const fieldById = fields.find(x => x.id === fieldId);

    return fieldById ? fieldById.name : "Unknown";
  };

  const selectedField = getSelectedField(calculation, fields);
  const selectedFieldValue = Boolean(selectedField) && selectedField.value;
  const selectedFieldFormattedValue = Boolean(selectedField) && selectedField.formattedValue;
  const value = parseFloat( selectedFieldValue || selectedFieldFormattedValue || 0);

  const amountOfDecimals = 2;
  const decimalsForField = selectedField.isHardCoded && selectedField.type === "basis-points" ? 0 : amountOfDecimals;

  return (
    <div key={calculation.id}>
      <Row {...rowProps}>
        <Grid container>
          <FieldWrapper>
            <FieldLeftContentWrapper>
              <FieldIconWrapper>
                <img src={CalcIconBlue} alt="Calc Icon" height={24} width={24} />
              </FieldIconWrapper>
              <FieldNameTypeWrapper>
                {!calculation.fieldId && <FieldNameWrapper>Select a field</FieldNameWrapper>}
                {Boolean(calculation.fieldId) && <FieldNameWrapper>{getFieldName(calculation.fieldId)}</FieldNameWrapper>}
                <RemoveWrapper onClick={() => onRemoveCalculation(calculation)}>Remove</RemoveWrapper>
              </FieldNameTypeWrapper>
            </FieldLeftContentWrapper>
            {!selectedField && (
              <FieldRightContentWrapper onClick={() => onSelectNewField(calculation)}>
                <FieldLevelWrapper>Select</FieldLevelWrapper>
                <StyledChevronRight />
              </FieldRightContentWrapper>
            )}
            {Boolean(selectedField) && (
              <FieldRightContentWrapper>
                {selectedField.isHardCoded && (selectedField.type === "dollars" || selectedField.type === "mm") ? (
                  <LabelDollarFormatted value={value} decimals={2} />
                ) : (
                  <LabelDecimal value={value} decimals={decimalsForField} />
                )}
              </FieldRightContentWrapper>
            )}
          </FieldWrapper>
        </Grid>
      </Row>
      {idx + 1 !== numberOfCalculations ? <OperationsBar calculation={calculation} onSetOperation={onSetOperation} /> : null}
    </div>
  );
};

export default PredefinedCalculationField;
